import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiUsers, FiFileText, FiBarChart2, FiUserCheck } from 'react-icons/fi';

const EmployeeDashboard = () => {
  const [employeeName, setEmployeeName] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const employee = JSON.parse(localStorage.getItem('employee'));
    if (!employee) {
      navigate('/employee-login');
      return;
    }
    setEmployeeName(employee.name);
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [navigate]);

  const modules = [
    { name: 'Rider Crm', icon: FiUsers, link: 'https://infrec.in/rider/' },
    { name: 'Iquote', icon: FiFileText, link: 'https://infrec.in/iquote/' },
    { name: 'Report', icon: FiBarChart2, link: 'https://infrec.in/report/' },
    { name: 'HRMs', icon: FiUserCheck, link: '#' }
  ];

  return (
    <div className="h-screen bg-gray-100 p-4 overflow-hidden flex items-center" style={{ marginTop: '-80px' }}>
      <div className="max-w-6xl mx-auto w-full">
        <div className="mb-16 text-center">
          <h1 className="text-5xl font-bold text-gray-800">Welcome, {employeeName}</h1>
        </div>
        
        <div className="grid grid-cols-4 gap-6">
          {modules.map((module, index) => (
            <a
              key={index}
              href={module.link}
              className="bg-white rounded-lg shadow-lg cursor-pointer hover:shadow-2xl hover:scale-105 transition-all duration-300 border-2 aspect-square flex flex-col items-center justify-center p-6"
              style={{ borderColor: '#305daa' }}
            >
              <div className="w-20 h-20 flex items-center justify-center" style={{ backgroundColor: '#305daa' }}>
                <module.icon className="w-10 h-10 text-white" />
              </div>
              <h2 className="text-lg font-bold text-center mt-4" style={{ color: '#305daa' }}>{module.name}</h2>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EmployeeDashboard;
